import PropTypes from 'prop-types';

import * as Styled from './SidePanel.style';

/**
 * Generic side panel container that can hold SelectionPanel, ProfilePanel, or both
 * Provides consistent sidebar layout and styling across report components
 *
 * @param {object} props - Component props
 * @param {import('react').ReactNode} [props.profilePanel] - ProfilePanel component or profile panel content
 * @param {import('react').ReactNode} [props.selectionPanel] - SelectionPanel component or selection panel content
 * @param {import('react').ReactNode} [props.children] - Additional content to render in the sidebar
 * @returns {import('react').ReactElement|null} The side panel component or null
 * @component
 */
function SidePanel({ profilePanel, selectionPanel, children }) {
  const hasContent = profilePanel || selectionPanel || children;

  if (!hasContent) {
    return null;
  }

  return (
    <Styled.SidePanelRoot>
      {profilePanel && <Styled.SidePanelSection>{profilePanel}</Styled.SidePanelSection>}
      {selectionPanel && <Styled.SidePanelSection>{selectionPanel}</Styled.SidePanelSection>}
      {children && <Styled.SidePanelSection>{children}</Styled.SidePanelSection>}
    </Styled.SidePanelRoot>
  );
}

SidePanel.propTypes = {
  profilePanel: PropTypes.node,
  selectionPanel: PropTypes.node,
  children: PropTypes.node
};

export default SidePanel;
